"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowWeWork() {
  const steps = [{
    number: "01",
    title: "Initial Consultation",
    description: "We begin with a comprehensive assessment of your property and discuss your unique estate management needs in complete confidence."
  }, {
    number: "02",
    title: "Customized Plan Development",
    description: "Our team crafts a tailored property management strategy that addresses every aspect of your estate operations and concierge requirements."
  }, {
    number: "03",
    title: "Seamless Implementation",
    description: "We execute the plan with meticulous attention to detail, ensuring all systems, security, and services are operating at the highest standard."
  }, {
    number: "04",
    title: "Ongoing Oversight & Support",
    description: "Our dedicated professionals provide continuous estate monitoring, proactive maintenance coordination, and discreet client support around the clock."
  }];
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: section4Ref,
    isVisible: section4Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const refs = [section1Ref, section2Ref, section3Ref, section4Ref];
  const visibleStates = [section1Visible, section2Visible, section3Visible, section4Visible];
  return <section id="how-we-work" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-foreground mb-4">
            How We Work
          </h2>
          <p className="text-lg max-w-2xl mx-auto !bg-transparent !text-[hsl(0,0%,100%)]">
            Our proven approach ensures your estate receives exceptional care and attention at every stage.
          </p>
        </div>

        <div className="space-y-0">
          {steps.map((step, i) => <div key={i} data-index={i} ref={refs[i]} className="flex gap-6 py-8 border-b border-border transition-all duration-[var(--duration-medium)] px-6 opacity-100 translate-y-0 !bg-transparent md:gap-8 last:border-b-0 md:px-8">
              <div className="shrink-0">
                <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary text-foreground-primary font-display text-xl md:text-2xl font-semibold">
                  {step.number}
                </div>
              </div>
              
              <div className="flex-1 pt-1">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground mb-2">
                  {step.title}
                </h3>
                <p className="leading-relaxed !text-[hsl(0,0%,100%)]">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}